import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoRobotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 192,
	height: 192,
	viewBox: "0 0 192 192",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M87.5179 110.875L90.9319 109.9C94.2444 108.953 97.7557 108.953 101.068 109.9L104.482 110.875M96 68.0178C99.4518 68.0178 102.25 65.2196 102.25 61.7678C102.25 58.316 99.4518 55.5178 96 55.5178C92.5482 55.5178 89.75 58.316 89.75 61.7678C89.75 65.2196 92.5482 68.0178 96 68.0178ZM96 68.0178V76.0535M66.5357 80.0535C66.5357 77.8444 68.3266 76.0535 70.5357 76.0535H121.464C123.673 76.0535 125.464 77.8444 125.464 80.0535V121.482C125.464 122.034 125.017 122.482 124.464 122.482H67.5357C66.9834 122.482 66.5357 122.034 66.5357 121.482V80.0535ZM89.6384 92.8585C89.6384 95.7292 87.2649 98.0563 84.3371 98.0563C81.4092 98.0563 79.0357 95.7292 79.0357 92.8585C79.0357 89.9878 81.4092 87.6607 84.3371 87.6607C87.2649 87.6607 89.6384 89.9878 89.6384 92.8585ZM112.964 92.8585C112.964 95.7292 110.591 98.0563 107.663 98.0563C104.735 98.0563 102.362 95.7292 102.362 92.8585C102.362 89.9878 104.735 87.6607 107.663 87.6607C110.591 87.6607 112.964 89.9878 112.964 92.8585ZM58.5 97.4821C58.5 101.92 62.0977 105.518 66.5357 105.518V89.4464C62.0977 89.4464 58.5 93.0441 58.5 97.4821ZM125.464 105.518C129.902 105.518 133.5 101.92 133.5 97.4821C133.5 93.0441 129.902 89.4464 125.464 89.4464V105.518Z",
		stroke: "#272525",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M59.9375 59.9375C59.9375 59.9375 62.0466 62.0466 64.6484 64.6484L127.352 127.352C129.953 129.953 132.062 132.062 132.062 132.062M44.5 96C44.5 67.5573 67.5573 44.5 96 44.5C124.443 44.5 147.5 67.5573 147.5 96C147.5 124.443 124.443 147.5 96 147.5C67.5573 147.5 44.5 124.443 44.5 96Z",
		stroke: "#272525",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgNoRobotFound;
